import script from "./404.vue?vue&type=script&setup=true&lang=js"
export * from "./404.vue?vue&type=script&setup=true&lang=js"

import "./404.vue?vue&type=style&index=0&id=3b971b8e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b971b8e"]])

export default __exports__